var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"https://hmny-governance.netlify.app/#","width":"100%","height":"100%"}},[_vm._v("Your browser does not support iframes! ")])}
var staticRenderFns = []

export { render, staticRenderFns }